export default "__VITE_ASSET__Bk_LT_xM__"